<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import u from "./assets/js/util.js";

export default {
  name: "App",
  mounted() {
    u.setCookie("module", "public");
  },
};
</script>

<style>
.popover-content {
  color: white; /* 白色文字 */
  padding: 10px;
  border-radius: 4px;
}

.cencent {
  overflow: hidden;
  position: absolute;
  width: calc(100%);
  height: calc(100%);
  box-sizing: content-box;
}

.top {
  height: 40px;
  text-align: right;
  line-height: 40px;
  padding-left: 20px;
  padding-right: 20px;
}

.bottom {
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  justify-content: space-between;
}

.pointer {
  cursor: pointer;
}

.status_active {
  margin-left: 15px;
  cursor: pointer;
  color: #2271d8;
  font-size: 14px;
}

.cencent_blac {
  background-color: #ffffff;
}

.title {
  display: flex;
  background-color: #ffffff;
  padding: 10px;
  width: calc(100% - 40px);
  border-radius: 2px;
}

.subject {
  width: 100%;
  background-color: #ffffff;
  height: calc(100% - 70px);
  border-radius: 2px;
}

.cursor {
  cursor: pointer;
}

.cursor:hover {
  color: #2174ff;
}

.active {
  color: #2174ff;
  font-weight: 600;
}

.btn-txt {
  color: #2174ff;
  cursor: pointer;
}

.btn-error {
  color: #ff3c32;
  cursor: pointer;
}

.btn-success {
  color: #26bf4c;
  cursor: pointer;
  user-select: none;
}

.el-dialog__header {
  padding: 10px;
}

.el-dialog__body {
  padding: 15px;
}
.el-dialog__body {
  padding: 15px;
}

.el-select.el-select--mini {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue